import React from 'react'
import styles from './Overview.less'

import CustomSelector from './CustomSelector'
class Overview extends React.Component {
  constructor(props) {
    super(props)
    this.handleSelectChange = props.onSelectChange
    this.options = props.list.map(item => ({ label: item.serviceCenterName, value: item.number, chainName: item.chainName }))
    this.handleChange = this.handleChange.bind(this)
    this.getLangMsg = props.getLangMsg
    this.state = {
      chainName: this.options.length ? this.options[0].chainName : ''
    }
  }

  handleChange(item) {
    this.setState({
      chainName: item.chainName
    })
    this.handleSelectChange(item.value)
  }

  render() {
    const { blockNumber, nodeNumber, runningDays, totalTransactions } = this.props.result
    return (
      <div className={styles['wrapper_left']}>
        <p className={styles['top-title']}>{this.getLangMsg('nodes.key0001')}</p>
			  
        <div className={ styles['form-item-ctn'] }>
          <p className={styles['form-title']}>{this.getLangMsg('nodes.key0002')}</p>
          <CustomSelector options={this.options} onChange={this.handleChange}></CustomSelector>
        </div>
        
        <div className={styles['form-item-ctn']}>
          <p className={styles['form-title']}>{this.getLangMsg('nodes.key0003')}</p>
          <p className={styles['form-value']}>{ this.state.chainName }</p>
        </div>				

        <p className={styles['detail-label']}>
        {this.getLangMsg('nodes.key0004')}
          <span className={styles['detail-key']}>{nodeNumber}</span>
          {this.getLangMsg('nodes.key0008')}
        </p>
        <p className={styles['detail-label']}>
        {this.getLangMsg('nodes.key0005')}
          <span className={styles['detail-key']}>{blockNumber}</span>
          {this.getLangMsg('nodes.key0008')}
        </p>
        <p className={styles['detail-label']}>
        {this.getLangMsg('nodes.key0006')}
          <span className={styles['detail-key']}>{totalTransactions}</span>
          {this.getLangMsg('nodes.key0009')}
        </p>
        <p className={styles['detail-label']}>
        {this.getLangMsg('nodes.key0007')}
          <span className={styles['detail-key']}>{runningDays}</span>
          {this.getLangMsg('nodes.key0010')}
        </p>
			</div>
    )
  }
}

export default Overview